import { useContext } from 'react';
import { NotificationPreferencesContext } from '../contexts/NotificationPreferencesContext';

/**
 * Hook to access notification preferences
 *
 * Usage:
 * ```tsx
 * const { preferences, updatePreferences, shouldShowNotification } = useNotificationPreferences();
 *
 * // Check if should show notification
 * if (shouldShowNotification('access_granted')) {
 *   toast.success('Access granted!');
 * }
 *
 * // Update preferences
 * updatePreferences({ showToasts: false });
 * ```
 */
export const useNotificationPreferences = () => {
  const context = useContext(NotificationPreferencesContext);

  if (!context) {
    throw new Error(
      'useNotificationPreferences must be used within NotificationPreferencesProvider'
    );
  }

  return context;
};
